import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { ThemeService } from '../services/theme.service';

@Directive({
  selector: '[dashboardButton]'
})
export class DashboardButtonThemeDirective {
  public themeItems: any;
  public baseUrl: string;
  public mainBackground: string;
  public primaryColor: string;
  themes: any;
  theme: any;
  themeList: any;

  constructor(public el: ElementRef, public renderer: Renderer2, private themeService: ThemeService) {
    this.themes = this.themeService.getThemeList().once('value', aliasSnapshot => {
      this.themeList = [];
      aliasSnapshot.forEach(snap => {
        if (snap.val().active === 'true') {
          console.log('snap', snap.val().alias);
          this.themeList.push({
            baseUrl: snap.val().baseurl,
            primaryColor: snap.val().primary_color,
            secondaryColor: snap.val().secondary_color,
            tertiaryColor: snap.val().tertiary_color,
            secondaryFontColor: snap.val().secondary_font_color
          });
        }
      });

      this.renderer.setStyle(el.nativeElement, 'color', this.themeList[0].secondaryFontColor);
      this.renderer.setStyle(el.nativeElement, 'border', this.themeList[0].secondaryColor + ' 1px solid');
      this.renderer.setStyle(el.nativeElement, 'background-color', this.themeList[0].tertiaryColor + '80');
    });
  }

}
